import { FIRST_DEMO_INVENTORY_ENTER_POPUP } from 'swag-client-common/constants';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
export const openFirstDemoInventoryEnterPopup = dispatch => {
  dispatch(showPopup({
    popup: FIRST_DEMO_INVENTORY_ENTER_POPUP
  }));
};